import React, { Component } from 'react';
import './DocumentatuionCss.css';

export class Documentation extends Component {
  render() {
    // Сериалы — две карточки без цены
    const seriesCards = [
      {
        title: 'Стоимость',
        bullets: [
          'Серии до 60 минут — 400 ₽',
          'Серии до 30 минут — 200 ₽',
          'Субтитры — +100 ₽ к каждой серии (хронометраж не важен)',
        ],
      },
      {
        title: 'Правила и ограничения',
        bullets: [
          'За раз можно заказать не более одного сезона',
          'Мультсериалы и аниме - по договоренности со стримером',
          'Контент должен быть Twitch-friendly',
          'Если заказаны уже 2 сериала — приём новых приостанавливается',
          'Максимум один слот от одного человека',
        ],
      },
    ];

    // Другое — карточки как были, с ценой
    const otherCards = [
      {
        title: 'Кино вне аукциона',
        badge: '1000 ₽',
        bullets: [
          'Заказ кино, мультфильма до  3 часов',
          'Смотрится в порядке очереди по договоренности со стримером',
        ],
      },
      {
        title: '12 часов стрима',
        badge: '10 000 ₽',
        bullets: [
          'Формат: марафон-стрим',
          'День выбирает стример',
          'Подходит под особые события/ивенты',
        ],
      },
      // {
      //   title: 'Косплей + ИИ М. Джей',
      //   badge: '2000 ₽',
      //   bullets: [
      //     'Стрим в косплее Мэри Джейн',
      //     'Плюс ИИ-версия М. Джей в эфире',
      //     'Формат обсуждается заранее',
      //   ],
      // },
    ];

    return (
      <section className="docs">
        <div className="docs__header">
          <h2 className="docs__title">Документация</h2>
        </div>

        <div className="docs__layout">
          {/* LEFT: СЕРИАЛЫ */}
          <div className="docsBlock">
            <div className="docsBlock__head docsBlock__head--center">
              <h3 className="docsBlock__title">Сериалы</h3>
            </div>

            <div className="docsGrid docsGrid--series">
                {seriesCards.map((card, idx) => (
                    <div
                        className={`docCard ${idx === 0 ? 'docCard--cost' : 'docCard--rules'}`}
                        key={idx}
                    >
                    <div className="docCard__head">
                        <div className="docCard__title docCard__title--center">
                            {card.title}
                        </div>
                    </div>

                    <ul className="docCard__list docCard__list--series">
                        {card.bullets.map((b, i) => (
                            <li key={i}>{b}</li>
                        ))}
                    </ul>
                    </div>
                ))}
            </div>
          </div>

          {/* RIGHT: ДРУГОЕ */}
          <div className="docsBlock">
            <div className="docsBlock__head docsBlock__head--center">
              <h3 className="docsBlock__title">Другое</h3>
              {/* красный бейдж “Разовые форматы” — УБРАН */}
            </div>

            <div className="docsGrid">
              {otherCards.map((card, idx) => (
                <div className="docCard" key={idx}>
                  <div className="docCard__head">
                    <div className="docCard__title">{card.title}</div>
                    <div className="docCard__badge">{card.badge}</div>
                  </div>

                  <ul className="docCard__list">
                    {card.bullets.map((b, i) => (
                      <li key={i}>{b}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Documentation;